import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

import { RightRepentanceRoutingModule } from '@right-repentance/right-repentance-routing.module';
import { RightRepentanceComponent } from '@right-repentance/components/AR/right-repentance.component';
import { ModalModule } from '@ux/components/modal/modal.module';

@NgModule({
  declarations: [RightRepentanceComponent],
  imports: [
    CommonModule,
    RightRepentanceRoutingModule,
    TranslocoModule,
    ModalModule
  ]
})
export class RightRepentanceModule { }
